// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isFunction',
    standalone: false,
})
export class IsFunctionPipe implements PipeTransform {
    transform (input: any): boolean {
        return typeof input === 'function';
    }
}
